module.exports = __webpack_public_path__ + "static/img/icon_video1.5ed7065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_video1.jpg
// module id = b+4h
// module chunks = 21